// extracted by mini-css-extract-plugin
module.exports = {"instructions":"Instructions_instructions__3-4Tw"};